export enum Language {
	Default = 'en',
	Arabic = 'ar',
	French = 'fr-FR',
	Lithuanian = 'lt-LT',
	Nederlands = 'nl-NL',
	Russian = 'ru-RU',
	Italian = 'it-IT',
	Korean = 'ko-KR',
	Eesti = 'et-EE',
	Chinease = 'zh-CN',
	Portugal = 'pt-BR',
	PortugalDefault = 'pt-PT',
	Polish = 'pl-PL',
	Spanish = 'es-ES',
	Greek = 'el-GR',
	Latvian = 'lv-LV',
	Ukrainian = 'uk-UA',
	Deutsch = 'de-DE',
}

export enum ActionType {
	HideCookies = 'HIDE_COOKIES_WARNING',
	ShowCookies = 'SHOW_COOKIES_WARNING',
	SetEmergencyMessage = 'SET_EMERGENCY_MESSAGE',
}

export enum StorageCookie {
	DefaultLanguage = 'defaultLanguage',
	CurrentLanguage = 'currentLang',
}

export enum Cookies {
	Statistical = 'statisticalCookie',
	Preference = 'preferenceCookie',
	Marketing = 'marketingCookie',
}

// export enum PageType {
// 	Main = 'MAIN',
// 	MainMinimal = 'MAIN_MINIMAL',
// 	Policy = 'POLICY',
// 	Documentation = 'DOCUMENTATION',
// 	FAQ = 'FAQ',
// 	Events = 'EVENTS',
// 	API = 'API',
// }

export enum PageType {
	Main,
	MainMinimal,
	Policy,
	Documentation,
	FAQ,
	Events,
	API,
}
